var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_action)?_c('GenericDownloadEvidenceOptions',{attrs:{"size":_vm.size,"unit":_vm.unit.document_downloads_options,"loading":_vm.loading,"color":_vm.color},on:{"loading_start":_vm.loading_start,"loading_stop":_vm.loading_stop,"option_click":_vm.handle_evidence}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }